import { queryOptions, useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api-client'
import { QueryConfig } from '@/lib/react-query'
import { ChargebeePlan } from '../types/chargebee'

export const getChargebeePlan = (id: string): Promise<ChargebeePlan> => {
    return api.get(`/v2/chargebee/plans/${id}`)
}

export const getChargebeePlanQueryOptions = (planId: string) => {
    return queryOptions({
        queryKey: ['chargebee-plans', planId],
        queryFn: () => getChargebeePlan(planId),
    })
}

type UseChargebeePlanOptions = {
    planId: string
    queryConfig?: QueryConfig<typeof getChargebeePlan>
}

export const useChargebeePlan = ({ planId, queryConfig }: UseChargebeePlanOptions) => {
    return useQuery({
        ...getChargebeePlanQueryOptions(planId),
        ...queryConfig,
    })
}


